/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Agent status management event (2025 pattern) */
export type AgentStatusChangedEvent = {
  /** Agent public key */
  agent: Address;
  /** Previous status */
  previousStatus: boolean;
  /** New status */
  newStatus: boolean;
  /** Change timestamp */
  timestamp: bigint;
  /** Owner who made the change */
  authority: Address;
};

export type AgentStatusChangedEventArgs = {
  /** Agent public key */
  agent: Address;
  /** Previous status */
  previousStatus: boolean;
  /** New status */
  newStatus: boolean;
  /** Change timestamp */
  timestamp: number | bigint;
  /** Owner who made the change */
  authority: Address;
};

export function getAgentStatusChangedEventEncoder(): FixedSizeEncoder<AgentStatusChangedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["previousStatus", getBooleanEncoder()],
    ["newStatus", getBooleanEncoder()],
    ["timestamp", getI64Encoder()],
    ["authority", getAddressEncoder()],
  ]);
}

export function getAgentStatusChangedEventDecoder(): FixedSizeDecoder<AgentStatusChangedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["previousStatus", getBooleanDecoder()],
    ["newStatus", getBooleanDecoder()],
    ["timestamp", getI64Decoder()],
    ["authority", getAddressDecoder()],
  ]);
}

export function getAgentStatusChangedEventCodec(): FixedSizeCodec<
  AgentStatusChangedEventArgs,
  AgentStatusChangedEvent
> {
  return combineCodec(
    getAgentStatusChangedEventEncoder(),
    getAgentStatusChangedEventDecoder(),
  );
}
